import { ShowAlertAndRedirectReaction } from 'services/Main/types.Component';
import history from 'utils/history';

export default ({ alertText, redirectTo }: ShowAlertAndRedirectReaction) => {
  alert(alertText);
  history.push(redirectTo);
};
